// Components
// Hooks
import useSPGroups from '@/utils/hooks/swr/group/useSPGroups';
// Types
import type {
    RequestParamsType,
    SetRequestParamsType
} from '@/utils/hooks/swr/reports/useFetchReports';

import InputSearchFilter from '@/components/pages/reports/components/TableFilters/InputSearchFilter';
import SelectReportTypeFilter from '@/components/pages/reports/components/TableFilters/SelectReportTypeFilter';
import SelectShowFilter from '@/components/pages/reports/components/TableFilters/SelectShowFilter';
import SelectSocialProfilesFilter from '@/components/pages/reports/components/TableFilters/SelectSocialProfilesFilter';
import SelectSpGroupsFilter from '@/components/pages/reports/components/TableFilters/SelectSpGroupsFilter';

type TableFiltersProps = {
    reportType: 'history' | 'frequency';
    requestParams: RequestParamsType;
    setRequestParams: SetRequestParamsType;
};

const TableFilters = ({ reportType, requestParams, setRequestParams }: TableFiltersProps) => {
    const { spGroups } = useSPGroups({
        revalidateOnMount: false,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false
    });

    return (
        <div className="manipulation-header mb-5 flex flex-col gap-y-2 @2xl:flex-row @2xl:gap-x-3 @2xl:gap-y-0">
            <InputSearchFilter setRequestParams={setRequestParams} />
            <SelectSocialProfilesFilter
                requestParams={requestParams}
                setRequestParams={setRequestParams}
            />
            {spGroups?.length ? (
                <SelectSpGroupsFilter
                    requestParams={requestParams}
                    setRequestParams={setRequestParams}
                />
            ) : null}
            <SelectReportTypeFilter
                reportType={reportType}
                requestParams={requestParams}
                setRequestParams={setRequestParams}
            />
            <SelectShowFilter requestParams={requestParams} setRequestParams={setRequestParams} />
        </div>
    );
};

export default TableFilters;
